import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid } from '@mui/material'
import { useContext } from 'react'
import { formatDateAccordingToTimezoneUsingMoment, hasInboxReadAccess } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconsColor from '../../../../../components/utility/iconsColor';
import { manualAgentData } from '../../../../../models/axiosModel';
import { deleteIconColor } from '../../../../../utils/colors';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { renderUserAvatarDp } from '../../../renderUtils';
import { getAgentName, hasAccessToAssignAgent } from '../../../utils';
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";
import GlobalTooltip from '../../../../../components/utility/tooltip/globalTooltip';

interface AgentDataTabContentProps {
    onRemoveAgent: (e: any, agent: manualAgentData) => void,
    renderNoInfoAvailableBlock: (text: string) => JSX.Element
}

const renderAgentInfo = (agent: manualAgentData, timestamp_joined: boolean, timezoneHour: string) => {
    let agent_name = getAgentName(agent);
    return (
        <Grid item>
            <Grid container gap={"5px"} direction={"column"}>
                <Grid item className={styles.messageEntryValue}>
                    {timestamp_joined ? `${agent_name} has joined conversation`
                        :
                        `${agent_name} has been assigned`
                    }
                </Grid>
                <Grid item className={styles.chatInfoBlockAssignAgentTimeStamp}>
                    {formatDateAccordingToTimezoneUsingMoment(timestamp_joined ? agent.timestamp_joined : agent.timestamp_assigned, timezoneHour)}
                </Grid>
            </Grid>
        </Grid>
    );
}

const AgentDataTabContent = (props: AgentDataTabContentProps) => {
    const { onRemoveAgent, renderNoInfoAvailableBlock } = props
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload

    const { manualAgentData } = useRuleBasedInboxStore(useShallow((state) => {
        const thread = state.currentActiveChatbotThread;
        return {
            manualAgentData: thread && "manual_agent_data" in thread ? thread.manual_agent_data : undefined,
        };
    }))

    return (
        <>
            {(manualAgentData && manualAgentData.length > 0) ?
                <Grid container direction="column" spacing={2} className={styles.chatInfoBlockAgentDataContainer}>
                    {manualAgentData.map((agent: manualAgentData, ind: number) => {
                        return (<Accordion key={ind} className={clsx(styles.agentAccordion, styles.chatInfoBlockAgentDataAccordion)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className={styles.chatInfoBlockAgentDataAccordionSummary}
                            >
                                <Grid container justifyContent={"space-between"} alignItems={"center"} >
                                    <Grid item>
                                        <Grid container gap={"10px"} alignItems={"center"}>
                                            <Grid item className={globalStyles.displayFlexStyle}>
                                                {renderUserAvatarDp(getAgentName(agent), false)}
                                            </Grid>
                                            <Grid item className={clsx(styles.messageEntryValue, globalStyles.blackColor)}>
                                                {getAgentName(agent)}
                                            </Grid>
                                            <GlobalTooltip
                                                title={`${agent.timestamp_joined ? "Active" : "Not Joined"}`}
                                                placement="top"
                                                arrow
                                            >
                                                <Grid item className={clsx(styles.chatInfoBlockAgentStatus, agent.timestamp_joined ? styles.chatInfoBlockAgentJoined : styles.chatInfoBlockAgentAssigned)}>
                                                </Grid>
                                            </GlobalTooltip>
                                        </Grid>
                                    </Grid>
                                    {(hasAccessToAssignAgent(userDetail) && hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail))  &&
                                        <Grid item className={styles.deleteAgentIconGrid} onClick={(e) => { onRemoveAgent(e, agent) }}>
                                            <IconsColor iconName="DeleteIcon" height={"16"} width={"16"} fillColor={deleteIconColor} />
                                        </Grid>
                                    }
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails
                                className={clsx(styles.agentAccordion, styles.agentDataAccordionDetails)}
                            >
                                <Grid container direction={"column"} gap="8px" className={styles.agentDataAccordionDetailsContainer}>
                                    {agent.timestamp_joined &&
                                        <>
                                            {renderAgentInfo(agent, true, userDetail.timezone_hour)}
                                            <Grid item>
                                                <Divider className={styles.agentInfoDivider} />
                                            </Grid>
                                        </>
                                    }
                                    {agent.timestamp_assigned &&
                                        renderAgentInfo(agent, false, userDetail.timezone_hour)
                                    }
                                </Grid>
                            </AccordionDetails>
                        </Accordion>);
                    })}
                </Grid>
                :
                renderNoInfoAvailableBlock("No agent has been assigned yet.")
            }
        </>
    )
}

export default AgentDataTabContent
